import { defineMessages } from 'react-intl';

export default defineMessages({
  totalStake: 'Total Staked + Locked',
  poolShare: 'Pool Share',
  currentAPR: 'Current APR',
});
